import { moveContactsFailedDescription } from './moveContactsDataActions.locstring.json';
import { cancelLabel } from 'owa-locstrings/lib/strings/cancellabel.locstring.json';
import { somethingWentWrongLabel } from 'owa-locstrings/lib/strings/somethingwentwronglabel.locstring.json';
import loc, { format } from 'owa-localize';
import type { Dispatch } from 'redux';
import {
    createDataActionFactory,
    Feature,
    addNotification,
    hashFolderId,
    getLogSafeId,
} from '../../../shared';
import {
    moveContactsOperation,
    MoveItemsResults,
} from '../../dataLayer/ows/persona/moveContactsOperation';
import { personasContactsIdsFromFolderId } from '../../utils/personaConctactsFromFolderId';

import type { MoveContactsActionPayload } from '../../actions/user/moveContactActions';
import type { ItemId } from '../../../service';

export const moveContactsCompletedAction = createDataActionFactory<
    MoveContactsActionPayload & { contactIdsToNewContactIds: IdsToObjectIdsMap },
    Error & MoveContactsActionPayload
>(
    'MoveContactsCompletedAction',
    Feature.MoveContacts,
    action => {
        return {
            itemsInvolved: action.payload.personas.length,
            fromFolderId: hashFolderId(action.payload.fromFolderId),
            toFolderId: hashFolderId(action.payload.toFolderId),
            origin: action.payload.origin,
        };
    },
    action => {
        return {
            itemsInvolved: action.payload.personas.length,
            fromFolderId: hashFolderId(action.payload.fromFolderId),
            toFolderId: hashFolderId(action.payload.toFolderId),
            origin: action.payload.origin,
        };
    }
);

export function handleMoveContactsError(
    dispatch: Dispatch,
    error: Error,
    actionPayload: MoveContactsActionPayload
): void {
    dispatch(moveContactsCompletedAction.error({ ...error, ...actionPayload }));
    addNotification(
        loc(somethingWentWrongLabel),
        format(loc(moveContactsFailedDescription)),
        loc(cancelLabel)
    );
}

const logSafeIds = (contactIds: string[], fromFolderId: string, toFolderId: string) => ({
    contactIds: contactIds
        .map(contactId => getLogSafeId(contactId) + '_' + contactId.length)
        .join(','),
    fromFolderId: getLogSafeId(fromFolderId) + '_' + fromFolderId.length,
    toFolderId: getLogSafeId(toFolderId) + '_' + toFolderId.length,
});

export const moveContacts = (payload: MoveContactsActionPayload) => (dispatch: Dispatch) => {
    const contactIds = personasContactsIdsFromFolderId(payload.personas, payload.fromFolderId);
    const actionPayload = { ...payload, isMoveInProgress: false };
    const additionalLogProps = logSafeIds(contactIds, payload.fromFolderId, payload.toFolderId);
    moveContactsOperation(contactIds, payload.toFolderId, additionalLogProps).then(
        (response: MoveItemsResults) => {
            const idsToNewObjectIdsMap = createIdsToNewObjectIdsMap(response);
            dispatch(
                moveContactsCompletedAction.success({
                    ...actionPayload,
                    contactIdsToNewContactIds: idsToNewObjectIdsMap,
                })
            );
        },
        (error: Error) => {
            handleMoveContactsError(dispatch, Error('Error during moveContacts'), actionPayload);
        }
    );
};

export type IdsToObjectIdsMap = {
    [id: string]: ItemId;
};

const createIdsToNewObjectIdsMap = (response: MoveItemsResults): IdsToObjectIdsMap => {
    const resultMap = {};
    response.ItemIds.map((itemId, index) => {
        resultMap[itemId.Id] = response.nextItemIds[index];
    });
    return resultMap;
};
export type { DataActionFactory } from '../../../shared';
